import HttpRequest from "./request";

export class UploadGameProvider extends HttpRequest {
  constructor() {
    super(`${process.env.VUE_APP_SERVICE_GAME}/`);
  }

  async upload(url, form) {
    return await this.request(
      "POST",
      `${process.env.VUE_APP_SERVICE_GAME}${url}`,
      form,
      {
        headers: {
          Authorization: `Basic ${localStorage.getItem("accessToken")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
}
